var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picture',[_c('source',{attrs:{"data-srcset":_vm.srcsetWebp,"type":"image/webp"}}),_c('img',{staticClass:"lazyload",attrs:{"src":"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==","data-src":_vm.fullSrcUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }